export default __webpack_public_path__ + "static/media/README.96afb2f4.md";